/** Copyright © 2013-2026 DataYes, All Rights Reserved. */

import { lazy } from 'react';
import { Route, Switch } from 'react-router-dom';
const MaterialList = lazy(() => import('pages/material'));
const Setting = lazy(() => import('pages/setting'));
const Advertisement = lazy(() => import('pages/advertisement'));
const Group = lazy(() => import('pages/group'));
const Traincamp = lazy(() => import('pages/traincamp'));
const Coupon = lazy(() => import('pages/coupon'));
const Paper = lazy(() => import('pages/paper'));
const Tool = lazy(() => import('pages/tool'));
const Voucher = lazy(() => import('pages/voucher'));
const Distribution = lazy(() => import('pages/distribution'));
const Referral = lazy(() => import('pages/referral'));
const Mall = lazy(() => import('pages/mall'));
const Live = lazy(() => import('pages/live'));
const Information = lazy(() => import('pages/information'));
const Review = lazy(() => import('pages/review'));
const LiveCode = lazy(() => import('pages/live-code'));
const Theme = lazy(() => import('pages/theme'));
const Vanguard = lazy(() => import('pages/vanguard'));
const Column = lazy(() => import('pages/column'));
const Community = lazy(() => import('pages/community'));
const StrategyTutorial = lazy(() => import('pages/strategy-tutorial'));

const WanchaoUser = lazy(() => import('pages/wanchao/user'));
/**
 * @todo 课程创建没有完全重构好
 */
// const Course = lazy(() => import('pages/course'));
const CourseList = lazy(() => import('pages/course/list'));
const CourseGoodsList = lazy(() => import('pages/course/goods-list'));

/**
 * @deprecated
 */
const List = lazy(() => import('pages/list'));
const CreateEdit = lazy(() => import('pages/create_edit'));

export default function Routes() {
  return (
    <Switch>
      <Route path="/material/list" exact component={MaterialList} />
      <Route path="/setting" component={Setting} />
      <Route path="/advertisement" component={Advertisement} />
      <Route path="/group" component={Group} />
      <Route path="/traincamp" component={Traincamp} />
      <Route path="/coupon" component={Coupon} />
      <Route path="/paper" component={Paper} />
      <Route path="/tool" component={Tool} />
      <Route path="/voucher" component={Voucher} />
      <Route path="/distribution" component={Distribution} />
      <Route path="/referral" component={Referral} />
      <Route path="/mall" component={Mall} />
      <Route path="/live" component={Live} />
      <Route path="/information" component={Information} />
      <Route path="/review" component={Review} />
      <Route path="/live-code" component={LiveCode} />
      <Route path="/theme" component={Theme} />
      <Route path="/vanguard/:module" component={Vanguard} />
      <Route path="/column" component={Column} />
      <Route path="/community" component={Community} />
      <Route path="/strategy-tutorial" component={StrategyTutorial} />
      <Route path="/course/list" component={CourseList} exact />
      <Route path="/course/goods/list" component={CourseGoodsList} exact />
      {/* <Route path="/course" component={Course} /> */}
      <Route path="/wanchao/user" component={WanchaoUser} exact />
      {/* 下面这些是老代码，老的框架不太好维护，新的内容请使用新框架编写 */}
      {/* 还剩图文，策略，股票池没有重构 */}
      <Route path="/:type/list" exact component={List} />
      {/* 还剩图文，课程，策略，股票池没有重构 */}
      <Route path="/:type/create" component={CreateEdit} />
      <Route path="/:type/edit/:id" component={CreateEdit} />
    </Switch>
  );
}
